import React from "react";
import {Button} from "@appkit4/react-components/button"
import {Modal} from "@appkit4/react-components/modal"
import "../../styles/main.css"
import ModalFooter from "@appkit4/react-components/esm/modal/ModalFooter";
import PropTypes from "prop-types";
export default function ConformationModal(props) {

  return (
    <div >
      <Modal
        className="baseline-modal-showcase"
        visible={props.visible}
        onCancel={props.cancel}
        bodyStyle={{ maxHeight: "280px" }}
        footerStyle={{ paddingTop: "8px", marginTop: "-8px"}}
        modalStyle={{ width: "49.75rem" ,maxHeight:"fit-content" }}
        title={props.name}
      >
        <input
            className="cv-input-field"
            type="text"
            name="Assessorcomments" 
            placeholder="Add Your Comments"
          />
        <ModalFooter>
          <div className="modal-footer">
            <Button
              kind='primary'
              size='lg'
              onClick={props.cancel}
            >
              Approve
             </Button>

            <Button
              type="submit"
              kind='secondary'
              size='lg'
              onClick={props.cancel}
            >
              Reject
            </Button>

            <Button
              type="submit"
              kind='secondary'
              size='lg'
              onClick={props.cancel}
            >
              Cancel
            </Button>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  )
};

ConformationModal.propTypes = {
  visible: PropTypes.any,
  cancel: PropTypes.any,
  name: PropTypes.any
}
